export const UserRole = {
  Admin: 'Admin',
  Dealer: 'Dealer',
  Fleet: 'Fleet',
  Wholesaler: 'Wholesaler',
  Concierge: 'Concierge',
}
